export default "__VITE_ASSET__CgjYIhoy__"